const ItemBadge = ({item}) => {
    const isRevaluation = item.movementDetails?.type === 'REVALUATION';
    if (item.type === 'INCOME') {
        return <span className={`tx-item__badge tx-item__badge--${isRevaluation ? 'revaluation' : 'income'}`}>
            {isRevaluation ? 'Reval' : 'Income'}
        </span>;
    }
    if (item.type === 'TRANSFER') {
        return <span className="tx-item__badge tx-item__badge--transfer">Transfer</span>;
    }
    return <span className="tx-item__badge tx-item__badge--expense">Expense</span>;
};

export default ItemBadge;